import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BrandService } from 'src/app/services/brand.service';

@Component({
  standalone: false,
  selector: 'app-brands-detail',
  templateUrl: './brands-detail.component.html',
})
export class BrandsDetailComponent implements OnInit {
  id = '';
  isEditMode = false;
  validationTriggered = false;
  item: any = null;
  form: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brandService: BrandService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
    this.load();
  }

  load(): void {
    this.brandService.get(this.id).subscribe({
      next: (result) => {
        this.item = result?.data ?? null;
        this.resetForm();
        this.isEditMode = false;
        this.validationTriggered = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.toaster.error('Brand not found.');
        this.router.navigate(['/ecomm/brands']);
      },
    });
  }

  resetForm(): void {
    this.form = {
      name: this.item.name,
      sap_brand_id: this.item.sap_brand_id != null && this.item.sap_brand_id !== '' ? String(this.item.sap_brand_id) : '',
      status: this.item.status,
    };
  }

  startEdit(): void {
    this.resetForm();
    this.isEditMode = true;
    this.validationTriggered = false;
  }

  cancelEdit(): void {
    this.resetForm();
    this.isEditMode = false;
    this.validationTriggered = false;
  }

  save(): void {
    this.validationTriggered = true;
    if (!this.form.name) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      name: this.form.name,
      sap_brand_id: this.toNullableInt(this.form.sap_brand_id),
      status: Number(this.form.status),
    };

    this.brandService.update(this.id, payload).subscribe({
      next: (result) => {
        this.item = result.data;
        this.isEditMode = false;
        this.validationTriggered = false;
        this.toaster.success('Brand updated.');
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to update brand.');
      },
    });
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }

  onSapBrandIdInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, '');
    this.form.sap_brand_id = digits;
    if (input.value !== digits) {
      input.value = digits;
    }
  }

  /** Empty → null (avoid Number(null) === 0). */
  private toNullableInt(value: unknown): number | null {
    if (value === '' || value === null || value === undefined) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
}
